/**
 * 通用方法库
 * User: kevin
 * Date: 2019/5/31
 * Copyright: (c) 2019-2022 DUSTAR
 */


/**
 * 设置cookie
 *
 * @param {string} key 键
 * @param {string} value 值
 * @param {string|int} Hours 时间（单位：小时）
 * @return {void}
 */
export function setCookie(key, value, Hours = 3) {
    let exp = new Date();
    exp.setTime(exp.getTime() + Hours * 60 * 60 * 1000);
    document.cookie = key + "=" + escape(value) + ";expires=" + exp.toGMTString();
}


/**
 * 获取cookie
 *
 * @param {string} key 键
 * @return {string|null}
 */
export function getCookie(key) {
    let arr, reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
        return unescape(arr[2]);
    } else {
        return null;
    }
}

/**
 * 删除cookie
 *
 * @param {string} key 键
 * @return {void}
 */
export function delCookie(key) {
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let val = getCookie(key) || null;
    if (val != null) {
        document.cookie = key + "=" + val + ";expires=" + exp.toGMTString();
    }
}

/**
 * 获取URL参数
 *
 * @return {object}
 */
export function getUrlPath(url = undefined) {
    if (!url) {
        url = window.location.search;// 获取url中"?"符后的字串
    } else {
        url = url.split('?');
        if (url[1]) {
            url = '?' + url[1];
        }
    }

    let theRequest = {};
    if (url.indexOf("?") !== -1) {
        let str = url.substr(1),
            strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
    }

    return theRequest;
}


/**
 * 去除数组空值
 *
 * @param {array} array 处理前数组
 * @return {array}
 */
export function clearArrayEmpty(array) {
    for (let i = 0; i < array.length; i++) {
        if (array[i] === "" || typeof (array[i]) == "undefined") {
            array.splice(i, 1);
            i = i - 1;
        }
    }
    return array;
}


/**
 * 去除数组重复的值
 *
 * @param {array} arr 处理前数组
 * @return {array}
 */
export function uniqueArray(arr) {
    let tmp = [];
    for (let m in arr) {
        tmp[arr[m]] = 1;
    }
    //再把键和值的位置再次调换
    let tmpArr = [];
    for (let n in tmp) {
        if (!tmp.hasOwnProperty(n)) continue;
        tmpArr.push(n);
    }

    return tmpArr;
}

/**
 * 去除数组重复的值
 *
 * @param {int} length 字符串长度
 * @param charsType 随机字符范围
 * @return {string}
 */
export function strRandom(length, charsType = '0') {
    let charsArr = [
        '0123456789',
        'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
        'abcdefghijklmnopqrstuvwxyz'
    ];

    let chars = '';
    charsType = charsType.split(',');
    for (let i = 0; i < charsType.length; i++) {
        chars += charsArr[charsType[i]];
    }

    let charsLength = chars.length;
    let res = '';
    for (let i = 0; i < length; i++) {
        res += chars.charAt(Math.floor(Math.random() * charsLength));
    }

    return res;
}

/**
 * 时间戳转时间
 *
 * @param {string} nS 时间戳
 * @return {object}
 */
export function getLocalTime(nS) {
    return new Date(parseInt(nS) * 1000).toLocaleString().replace(/年|月/g, "-").replace(/日/g, " ");
}


/**
 * 随机数区间min ≤ r ≤ max
 *
 * @param {int} Min 最小值
 * @param {int} Max 最大值
 * @return {int}
 */
export function RandomNumBoth(Min, Max) {
    let Range = Max - Min;
    let Rand = Math.random();
    return Min + Math.round(Rand * Range); //四舍五入
}


/**
 * 随机数区间min ≤ r < max
 *
 * @param {int} Min 最小值
 * @param {int} Max 最大值
 * @return {int}
 */
export function RandomNumLeft(Min, Max) {
    let Range = Max - Min;
    let Rand = Math.random();
    return Min + Math.floor(Rand * Range); //舍去
}


/**
 * 随机数区间min < r ≤ max
 *
 * @param {int} Min 最小值
 * @param {int} Max 最大值
 * @return {int}
 */
export function RandomNumRight(Min, Max) {
    let Range = Max - Min;
    let Rand = Math.random();
    if (Math.round(Rand * Range) === 0) {
        return Min + 1;
    }

    return Min + Math.round(Rand * Range);
}


/**
 * 随机数区间min < r < max
 *
 * @param {int} Min 最小值
 * @param {int} Max 最大值
 * @return {int}
 */
export function RandomNumNone(Min, Max) {
    let Range = Max - Min;
    let Rand = Math.random();
    if (Math.round(Rand * Range) === 0) {
        return Min + 1;
    } else if (Math.round(Rand * Max) === Max) {
        index++;
        return Max - 1;
    } else {
        return Min + Math.round(Rand * Range) - 1;
    }
}

/**
 * html转码
 *
 * @param {string} str 需要转码的字符串
 * @return {string}
 */
export function htmlEncode(str) {
    let s = "";
    if (str.length === 0) return "";
    s = str.replace(/&/g, "&gt;");
    s = s.replace(/</g, "&lt;");
    s = s.replace(/>/g, "&gt;");
    s = s.replace(/ /g, "&nbsp;");
    s = s.replace(/\'/g, "&#39;");
    s = s.replace(/\"/g, "&quot;");
    s = s.replace(/\n/g, "<br>");
    return s;
}

/**
 * 浮点保留小数
 *
 * @param {float} src 浮点数字
 * @param {int} pos 保留位数
 * @return {number}
 */
export function formatFloat(src, pos) {
    return Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos);
}


export function formatMilliseconds(ms) {
    // 计算小时和分钟
    const hours = Math.floor(ms / 3600000); // 1小时 = 3600000毫秒
    const minutes = Math.floor((ms % 3600000) / 60000); // 1分钟 = 60000毫秒

    // 拼接格式化字符串
    let result = '';
    if (hours >= 0) result += `${hours}小时`;
    if (minutes >= 0) result += `${minutes}分`;

    return result.trim() || '0分'; // 若为 0，则返回 '0min'
}


export function formatTime(timestamp) {
    // 创建 Date 对象
    const date = new Date(parseInt(timestamp));
    // 获取小时和分钟
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    // 返回格式化后的时间字符串
    return `${hours}:${minutes}`;
}


/**
 * 数组去重
 *
 * @param {array} a 数组
 * @return {array}
 */
export function array_remove_repeat(a) {
    let r = [];
    for (let i = 0; i < a.length; i++) {
        let flag = true;
        let temp = a[i];
        for (let j = 0; j < r.length; j++) {
            if (temp === r[j]) {
                flag = false;
                break;
            }
        }
        if (flag) {
            r.push(temp);
        }
    }
    return r;
}

/**
 * 取数组交集
 *
 * @param {array} a 数组a
 * @param {array} b 数组b
 * @return {array}
 */
export function array_intersection(a, b) {
    let result = [];
    for (let i = 0; i < b.length; i++) {
        let temp = b[i];
        for (let j = 0; j < a.length; j++) {
            if (temp === a[j]) {
                result.push(temp);
                break;
            }
        }
    }
    return array_remove_repeat(result);
}

/**
 * 取数组并集
 *
 * @param {array} a 数组a
 * @param {array} b 数组b
 * @return {array}
 */
export function array_union(a, b) {
    return array_remove_repeat(a.concat(b));
}

/**
 * 取数组差集 a-b
 *
 * @param {array} a 数组a
 * @param {array} b 数组b
 * @return {array}
 */
export function array_difference(a, b) {
    //clone = a
    let clone = a.slice(0);
    for (let i = 0; i < b.length; i++) {
        let temp = b[i];
        for (let j = 0; j < clone.length; j++) {
            if (temp === clone[j]) {
                //remove clone[j]
                clone.splice(j, 1);
            }
        }
    }
    return array_remove_repeat(clone);
}

/**
 *  取数组次数
 *
 * @param {array} _arr 处理前数组
 * @return {array}
 */
export function array_count(_arr) {
    let _res = []; //
    _arr.sort();
    for (let i = 0; i < _arr.length;) {
        let count = 0;
        for (let j = i; j < _arr.length; j++) {
            if (_arr[i] === _arr[j]) {
                count++;
            }
        }
        _res.push([_arr[i], count]);
        i += count;
    }
    let _newArr = [];
    for (let i = 0; i < _res.length; i++) {
        // console.log(_res[i][0] + "重复次数:" + _res[i][1]);
        _newArr.push({
            val: _res[i][0],
            count: _res[i][1]
        });
    }
    return _newArr;
}

/**
 * 将100000转为100,000.00形式
 *
 * @param {int|string} money 处理前数字
 * @return {string}
 */
export function dealNumber(money) {
    if (money) {
        money = String(money);
        let left = money.split('.')[0], right = money.split('.')[1];
        right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
        let temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
        return (Number(money) < 0 ? "-" : "") + temp.join(',').split('').reverse().join('') + right;
    } else if (money === 0) {
        // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
        return '0.00';
    } else {
        return "";
    }
}

/**
 * 将100,000.00转为100000形式
 *
 * @param {string} search 要查询的字段
 * @param {array} array 查询的数组集合
 * @return {boolean}
 */
export function in_array(search, array) {
    for (let i in array) {
        if (!array.hasOwnProperty(i)) continue;
        if (array[i] === search) {
            return true;
        }
    }

    return false;
}

/**
 * 将100,000.00转为100000形式
 *
 * @param {string} money 处理前数字
 * @return {int|string}
 */
export function undoNubmer(money) {
    if (money) {
        money = String(money);
        let group = money.split('.');
        let left = group[0].split(',').join('');
        return Number(left + "." + group[1]);
    } else {
        return "";
    }
}

/**
 * js加载
 *
 * @param {string} url 链接地址
 * @return {boolean}
 */
export function loadScript(url) {
    let script = document.createElement("script")
    script.type = "text/javascript";
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

/**
 * 根据字符串位置替换字符串内容
 *
 * @param {string} text 原字符串
 * @param {number} begin 开始位置
 * @param {string} replace 替换的字符串
 * @return {string}
 */
export function changeStr(text, begin, replace) {
    let textArr = text.split('');
    let replaceArr = replace.split('');
    let index = begin - 1;
    for (let i = 0; i < replaceArr; i++) {
        textArr[index] = replaceArr[i];
        index++;
    }

    return textArr.join('');
}


/**
 * 动态删除style
 *
 * @param {string} id 标识 用于不二次覆盖使用
 */
export function removeStyle(id) {
    let dom = document.querySelector(`#${id}`);
    if (dom) {
        dom.remove();
    }
}

/**
 * 动态添加style
 *
 * @param {string} rules 规则
 * @param {string} id 标识 用于不二次覆盖使用
 */
export function addStyle(rules, id = '') {
    let styleElement = document.createElement('style');
    styleElement.setAttribute('type', 'text/css');
    if (id !== '') {
        let dom = document.querySelector(`#${id}`);
        if (dom) {
            dom.remove();
        }

        styleElement.setAttribute('id', id);
    }

    if (isIE()) {
        styleElement.styleSheet.cssText = rules;
    } else {
        let frag = document.createDocumentFragment();
        frag.appendChild(document.createTextNode(rules));
        styleElement.appendChild(frag);
    }

    document.getElementsByTagName('head')[0].appendChild(styleElement);
}

/**
 * 判断是否是IE浏览器
 *
 * @return {boolean}
 */
export function isIE() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
        return true;
    } else {
        return false;
    }
}

export function setLocalStorageByFight(key, data) {
    // 获取当前时间
    const now = new Date();
    // 创建凌晨 6 点的日期对象
    const target = new Date(now);
    target.setHours(6, 0, 0, 0); // 设置为今天的 6:00:00.000
    // 如果当前时间已经过了 6 点，则将目标时间设置为第二天的 6 点
    if (now > target) {
        target.setDate(target.getDate() + 1);
    }

    // 计算时间差（以毫秒为单位）
    const timeDifference = target - now;
    setLocalStorage(key, data, timeDifference);
}

export function setLocalStorage(key, data, expire = 86400 * 1000) {

  let copyData = JSON.parse(JSON.stringify(data));
  copyData.payUrl = "";
  copyData.payShow = "";

  localStorage.setItem(key, JSON.stringify({data:copyData, expire: Date.now() + expire}));
}


export function getLocalStorage(key) {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) return null;

  const item = JSON.parse(itemStr);

  if (Date.now() > item['expire']) {
    localStorage.removeItem(key); // 如果过期，删除数据
    return null;
  }

  console.log(item);
  return item.data;
}


export function calendarShow(date) {
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  let weekDay = "";
  switch (date.getDay()) {
    case 0:weekDay = '星期天';break;
    case 1:weekDay = '星期一';break;
    case 2:weekDay = '星期二';break;
    case 3:weekDay = '星期三';break;
    case 4:weekDay = '星期四';break;
    case 5:weekDay = '星期五';break;
    case 6:weekDay = '星期六';break;
  }

  return `${year}年${month}月${day}日 (${weekDay})`;
}


export function currentFightTime(calendarDefaultTime) {
  let min = calendarDefaultTime.getMinutes();
  let hours = calendarDefaultTime.getHours();
  if (min <= 30) {
    min = 30;
  } else {
    min = '00';hours = hours + 1;
  }

  return `${('0' + hours).slice(-2)}:${('0' + min).slice(-2)}`;
}



export function getYYYYMM(date = new Date()) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${year}${month}`;
}




export async function upload(fileInfo, axios, code) {
    let credentials = '';
    if (getCookie("credentials"))
        credentials = JSON.parse(getCookie("credentials"));

    if (isCredentialsExpired(credentials)) {
        let res = await axios.get('/get_sts_token_for_oss_upload?code=' + code);
        credentials = res;
        setCookie("credentials", JSON.stringify(res), 1);
    }

    if (credentials === '') return {res: {status: 10086}}

    const client = new OSS({
        // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
        region: 'oss-cn-hangzhou',
        // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
        accessKeyId: credentials['accessKeyId'],
        accessKeySecret: credentials['accessKeySecret'],
        // 从STS服务获取的安全令牌（SecurityToken）。
        stsToken: credentials['securityToken'],
        // 填写Bucket名称。
        bucket: 'dustar-upload'
    });


    let extension = fileInfo.type.split("/")[1];
    let fileName = Date.now() + '-' + strRandom(16, "0,2");
    try {
        return await client.put(`/client/eevee_upload/${getYYYYMM()}/${fileName}.${extension}` , fileInfo);
    } catch (e) {

    }

}


export function isCredentialsExpired(credentials) {
    if (!credentials) return true;
    const expireDate = new Date(credentials.expiration);
    const now = new Date();
    return expireDate.getTime() - now.getTime() <= 60000;
}



